export { default } from './TrendIndicator.js';
